import { useEffect, useState } from 'react'
import { rtpStats } from '../services/rtp-stats'
import type { RtpSnapshot } from '../services/rtp-stats'

/**
 * Live stats for one stream, while this component is mounted.
 *
 * Subscribing is what starts collection, so a panel that is closed costs
 * nothing — mount it only when it is actually shown rather than rendering it
 * hidden.
 *
 * `null` means no sample yet: the first poll fires immediately on subscribe,
 * but rates need two samples before they mean anything.
 */
export function useRtpStats(id: string | null | undefined): RtpSnapshot | null {
  const [snapshot, setSnapshot] = useState<RtpSnapshot | null>(null)

  useEffect(() => {
    setSnapshot(null)
    if (!id) return
    return rtpStats.subscribe(id, setSnapshot)
  }, [id])

  return snapshot
}
